import React from 'react'
import { Grid, Image, Segment } from 'semantic-ui-react'
import { Redirect, NavLink } from 'react-router-dom'

import './Setup.css'

const SetupPV = (props) => {
  if (props.auth) {
    if (props.userType === 'admin' || props.userType === 'principal' || props.userType === 'registrar') {
    return (
      <Segment className='module-panel'>
          <Grid>
           <Grid.Row centered columns={3}>
             <Grid.Column className='module-section'>
               <NavLink key="sy" to="/school-years">
                 <Image size='small' src='workbench/school-year.png' className='module-icon'/>
                 <p>School Year</p>
               </NavLink>
             </Grid.Column>
             <Grid.Column className='module-section'>
               <NavLink key="teachers" to="/teachers">
                 <Image size='small' src='workbench/teachers.png' className='module-icon'/>
                 <p>Teachers</p>
               </NavLink>
             </Grid.Column>
             <Grid.Column className='module-section'>
               <NavLink key="subjects" to="/subjects">
                 <Image size='small' src='workbench/subjects.png' className='module-icon'/>
                 <p>Subjects</p>
               </NavLink>
             </Grid.Column>
           </Grid.Row>
           <Grid.Row centered columns={3}>
             <Grid.Column className='module-section'>
               <NavLink key="clubs" to="/clubs">
                 <Image size='small' src='workbench/subjects.png' className='module-icon'/>
                 <p>Clubs</p>
               </NavLink>
             </Grid.Column>
             <Grid.Column className='module-section'>
               <NavLink key="sections" to="/sections">
                 <Image size='small' src='workbench/sections.png' className='module-icon'/>
                 <p>Sections</p>
               </NavLink>
             </Grid.Column>
             <Grid.Column className='module-section'>
               <NavLink key="classes" to="/classes">
                 <Image size='small' src='workbench/classes.png' className='module-icon'/>
                 <p>Classes</p>
               </NavLink>
             </Grid.Column>
             <Grid.Column className='module-section'>
               <NavLink key="reports" to="/reports">
                 <Image size='small' src='workbench/reports.png' className='module-icon'/>
                 <p>Reports</p>
               </NavLink>
             </Grid.Column>
           </Grid.Row>
         </Grid>
        </Segment>
    )
    } else {
      return <Segment>You are not authorized to be in this page.</Segment>
    }
  } else {
    return <Redirect to='/' />
  }

}

export default SetupPV;
